module.exports = __webpack_public_path__ + "img/logo_login.967e1eb5.png";